import React, { useState, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  CustomRule,
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import { changePassword } from '../../api/auth';
import { useAuth } from '../../contexts/auth';

export default function ChangePasswordForm() {
  const navigate = useNavigate();
  const { signInNewAccount } = useAuth();
  const [loading, setLoading] = useState(false);
  const formData = useRef({ code: '', password: '' });

  const onSubmit = useCallback(async (e) => {
    e.preventDefault();
    const { code, password } = formData.current;
    setLoading(true);

    try {
      const result = await changePassword(password, code);
      if (result.isOk) {
        const result2 = await signInNewAccount();
        if (result2.isOk) {
          setLoading(false);
          navigate('/home');
        } else {
          setLoading(false);
          notify(result.message, 'error', 2000);
        }
      } else {
        setLoading(false);
        notify(result.message, 'error', 2000);
      }
    } catch(error) {
        notify(error, 'error', 2000);
        setLoading(false);
    }

  }, [navigate, signInNewAccount]);

  const confirmPassword = useCallback(
    ({ value }) => value === formData.current.password,
    []
  );

  return (
    <form onSubmit={onSubmit}>
      <Form formData={formData.current} disabled={loading}>
        <Item
          dataField={'code'}
          editorType={'dxTextBox'}
          editorOptions={codeEditorOptions}
        >
          <RequiredRule message="Code is required" />
          <Label visible={false} />
        </Item>
        <Item
          dataField={'password'}
          editorType={'dxTextBox'}
          editorOptions={passwordEditorOptions}
        >
          <RequiredRule message="Password is required" />
          <Label visible={false} />
        </Item>
        <Item
          dataField={'confirmedPassword'}
          editorType={'dxTextBox'}
          editorOptions={confirmedPasswordEditorOptions}
        >
          <RequiredRule message="Password is required" />
          <CustomRule
            message={'Passwords do not match'}
            validationCallback={confirmPassword}
          />
          <Label visible={false} />
        </Item>
        <ButtonItem>
          <ButtonOptions
            width={'100%'}
            type={'default'}
            useSubmitBehavior={true}
          >
            <span className="dx-button-text">
              {
                loading
                  ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                  : 'Continue'
              }
            </span>
          </ButtonOptions>
        </ButtonItem>
      </Form>
    </form>
  );
}

const codeEditorOptions = { stylingMode: 'filled', placeholder: 'Confirmation Code', mode: 'text' };
const passwordEditorOptions = { stylingMode: 'filled', placeholder: 'Password', mode: 'password' };
const confirmedPasswordEditorOptions = { stylingMode: 'filled', placeholder: 'Confirm Password', mode: 'password' };
